import { render, staticRenderFns } from "./photo.vue?vue&type=template&id=54afc7f6&scoped=true&"
import script from "./photo.vue?vue&type=script&lang=js&"
export * from "./photo.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./photo.vue?vue&type=style&index=0&id=54afc7f6&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "54afc7f6",
  "75a1817e"
  
)

export default component.exports